// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.payMethodContainer_TpZJE {
  display: flex;
  gap: 10px;
  flex-direction: column;
  color: #1e0045;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  span {
    font-weight: 500;
  }
}

.payInfo_izinl {
  display: flex;
  gap: 10px;
  > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: var(--_2-color);
  }
  input,
  select,
  option {
    outline: none;
    border: none;
    background-color: var(--f4-background);
    color: var(--_75-color);
    padding: 12px;
    box-sizing: border-box;
  }
}

.defaultBank_egpy6 {
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 20px;
  gap: 30px;
  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  p {
    margin: 0;
    color: #2ebc89;
  }
  input {
    width: fit-content;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/PayMethod/PayMethod.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;EACxB;EACA;;;IAGE,aAAa;IACb,YAAY;IACZ,sCAAsC;IACtC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,SAAS;IACT,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["\n.payMethodContainer {\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n  color: #1e0045;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  span {\n    font-weight: 500;\n  }\n}\n\n.payInfo {\n  display: flex;\n  gap: 10px;\n  > div {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    color: var(--_2-color);\n  }\n  input,\n  select,\n  option {\n    outline: none;\n    border: none;\n    background-color: var(--f4-background);\n    color: var(--_75-color);\n    padding: 12px;\n    box-sizing: border-box;\n  }\n}\n\n.defaultBank {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding: 20px;\n  gap: 30px;\n  div {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  p {\n    margin: 0;\n    color: #2ebc89;\n  }\n  input {\n    width: fit-content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"payMethodContainer": `payMethodContainer_TpZJE`,
	"payInfo": `payInfo_izinl`,
	"defaultBank": `defaultBank_egpy6`
};
export default ___CSS_LOADER_EXPORT___;
